import React, { FC } from 'react';
import styled from '@emotion/styled';
import Icon from '~ComponentsImproved/Icon';
import ArrowIcon from '~Assets/icons/navigate-right.svg';
import { useButton, useI18n } from '~Hooks';
import { TransparentButton } from '~Styles/buttons';

const Wrapper = styled.div`
  display: flex;
  flex-flow: nowrap;
  overflow: auto;
  width: calc(100% - 200px);
  left: 0;
  position: absolute;
  top: 0;
  z-index: 1;
  background: rgba(17, 14, 22, 0.8);
  height: 64px;
  box-sizing: border-box;
  padding: 4px 16px;
  left: 200px;
  overflow: auto;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;

  & > div {
    margin: 0 8px;
  }
`;

const Button = styled(TransparentButton)<{ current: boolean }>`
  border-radius: 4px;
  border: 2px solid;
  border-color: ${({ current }) =>
    current ? 'var(--colorBlueGray600)' : 'var(--colorBlueGray400)'};
  text-transform: none;
  color: ${({ current }) => (current ? 'var(--colorBlueGray600)' : 'var(--colorWhite)')};
  max-width: 300px;
  pointer-events: ${({ current }) => (current ? 'none' : 'auto')};

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }
`;

export interface Props {
  breadcrumbs: { id: string; name: string }[];
  handleClick: (index: number) => void;
}

interface CrumbButtonProps {
  crumb: { id: string; name: string };
  current: boolean;
  onClick: () => void;
}

const CrumbButton: FC<CrumbButtonProps> = ({ crumb, current, onClick }) => {
  const { i18n } = useI18n();
  const btn = useButton({
    onClick: () => onClick(),
  });

  return (
    <Button {...btn} current={current}>
      <span>{i18n(crumb.name) ?? crumb.name}</span>
    </Button>
  );
};

const Breadcrumbs: FC<Props> = ({ breadcrumbs, handleClick }) => {
  return (
    <Wrapper>
      {breadcrumbs.map((crumb, i) => (
        <ButtonWrapper key={crumb.id}>
          <CrumbButton
            crumb={crumb}
            current={breadcrumbs.length === i + 1}
            onClick={() => handleClick(i)}
          />
          {breadcrumbs.length > i + 1 && <Icon src={ArrowIcon} />}
        </ButtonWrapper>
      ))}
    </Wrapper>
  );
};

export default Breadcrumbs;
